/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessLogResponse
 */
export interface AccessLogResponse {
    /**
     * 
     * @type {number}
     * @memberof AccessLogResponse
     */
    'failedAttempts'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccessLogResponse
     */
    'sentOtpCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccessLogResponse
     */
    'lastOtpSentAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccessLogResponse
     */
    'lastAttemptAt'?: string;
    /**
     * Admin status
     * @type {string}
     * @memberof AccessLogResponse
     */
    'status'?: AccessLogResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AccessLogResponse
     */
    'lockedUntil'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessLogResponse
     */
    'acceptedTerms'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccessLogResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccessLogResponse
     */
    'expiredOtp'?: boolean;
}

export const AccessLogResponseStatusEnum = {
    Active: 'active',
    ConfirmationSent: 'confirmationSent',
    Locked: 'locked'
} as const;

export type AccessLogResponseStatusEnum = typeof AccessLogResponseStatusEnum[keyof typeof AccessLogResponseStatusEnum];

/**
 * 
 * @export
 * @interface AdminAppsResponse
 */
export interface AdminAppsResponse {
    /**
     * 
     * @type {AdminDto}
     * @memberof AdminAppsResponse
     */
    'admin': AdminDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAppsResponse
     */
    'apps': Array<string>;
    /**
     * 
     * @type {Array<AuthorizedAppDto>}
     * @memberof AdminAppsResponse
     */
    'authorizedApps': Array<AuthorizedAppDto>;
}
/**
 * 
 * @export
 * @interface AdminDto
 */
export interface AdminDto {
    /**
     * 
     * @type {string}
     * @memberof AdminDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDto
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDto
     */
    'passwordSet': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminDto
     */
    'roles': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDto
     */
    'language': AdminDtoLanguageEnum;
    /**
     * 
     * @type {CustomClaimsDto}
     * @memberof AdminDto
     */
    'customClaims': CustomClaimsDto;
    /**
     * 
     * @type {string}
     * @memberof AdminDto
     */
    'type': AdminDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminDto
     */
    'role'?: string;
    /**
     * Terms of Service acceptance information
     * @type {TermsDto}
     * @memberof AdminDto
     */
    'terms'?: TermsDto;
}

export const AdminDtoLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type AdminDtoLanguageEnum = typeof AdminDtoLanguageEnum[keyof typeof AdminDtoLanguageEnum];
export const AdminDtoTypeEnum = {
    InternalLogin: 'internalLogin',
    Normal: 'normal',
    ServiceAccount: 'serviceAccount',
    Group: 'group'
} as const;

export type AdminDtoTypeEnum = typeof AdminDtoTypeEnum[keyof typeof AdminDtoTypeEnum];

/**
 * 
 * @export
 * @interface AdminInviteRequest
 */
export interface AdminInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminInviteRequest
     */
    'language'?: AdminInviteRequestLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteRequest
     */
    'appType': AdminInviteRequestAppTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteRequest
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteRequest
     */
    'type'?: AdminInviteRequestTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminInviteRequest
     */
    'roles'?: Array<AdminInviteRequestRolesEnum>;
}

export const AdminInviteRequestLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type AdminInviteRequestLanguageEnum = typeof AdminInviteRequestLanguageEnum[keyof typeof AdminInviteRequestLanguageEnum];
export const AdminInviteRequestAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AdminInviteRequestAppTypeEnum = typeof AdminInviteRequestAppTypeEnum[keyof typeof AdminInviteRequestAppTypeEnum];
export const AdminInviteRequestTypeEnum = {
    InternalLogin: 'internalLogin',
    Normal: 'normal',
    ServiceAccount: 'serviceAccount',
    Group: 'group'
} as const;

export type AdminInviteRequestTypeEnum = typeof AdminInviteRequestTypeEnum[keyof typeof AdminInviteRequestTypeEnum];
export const AdminInviteRequestRolesEnum = {
    SalesRep: 'pos.salesRep',
    SalesAdmin: 'pos.salesAdmin'
} as const;

export type AdminInviteRequestRolesEnum = typeof AdminInviteRequestRolesEnum[keyof typeof AdminInviteRequestRolesEnum];

/**
 * 
 * @export
 * @interface AdminInviteResponse
 */
export interface AdminInviteResponse {
    /**
     * 
     * @type {AdminDto}
     * @memberof AdminInviteResponse
     */
    'admin': AdminDto;
    /**
     * 
     * @type {AuthorizedAppDto}
     * @memberof AdminInviteResponse
     */
    'authorizedApp': AuthorizedAppDto;
}
/**
 * 
 * @export
 * @interface AdminInviteSetupRequest
 */
export interface AdminInviteSetupRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminInviteSetupRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteSetupRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminInviteSetupRequest
     */
    'lastName'?: string;
}
/**
 * 
 * @export
 * @interface AdminLoginRequest
 */
export interface AdminLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminLoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminLoginRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AdminLoginRequest
     */
    'appType'?: AdminLoginRequestAppTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminLoginRequest
     */
    'types'?: Array<AdminLoginRequestTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminLoginRequest
     */
    'acceptTerms'?: boolean;
}

export const AdminLoginRequestAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AdminLoginRequestAppTypeEnum = typeof AdminLoginRequestAppTypeEnum[keyof typeof AdminLoginRequestAppTypeEnum];
export const AdminLoginRequestTypesEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AdminLoginRequestTypesEnum = typeof AdminLoginRequestTypesEnum[keyof typeof AdminLoginRequestTypesEnum];

/**
 * 
 * @export
 * @interface AdminLoginResponse
 */
export interface AdminLoginResponse {
    /**
     * Temporary token for 2FA verification
     * @type {string}
     * @memberof AdminLoginResponse
     */
    'pending2FAToken'?: string;
    /**
     * Error
     * @type {AccessLogResponse}
     * @memberof AdminLoginResponse
     */
    'accessLog'?: AccessLogResponse;
}
/**
 * 
 * @export
 * @interface AdminOtpRegisterRequest
 */
export interface AdminOtpRegisterRequest {
    /**
     * User Email
     * @type {string}
     * @memberof AdminOtpRegisterRequest
     */
    'email': string;
    /**
     * App Type - CoreLoyalty preferable
     * @type {string}
     * @memberof AdminOtpRegisterRequest
     */
    'appType': AdminOtpRegisterRequestAppTypeEnum;
}

export const AdminOtpRegisterRequestAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AdminOtpRegisterRequestAppTypeEnum = typeof AdminOtpRegisterRequestAppTypeEnum[keyof typeof AdminOtpRegisterRequestAppTypeEnum];

/**
 * 
 * @export
 * @interface AdminOtpVerifyRequest
 */
export interface AdminOtpVerifyRequest {
    /**
     * The One-Time Password sent in the email
     * @type {string}
     * @memberof AdminOtpVerifyRequest
     */
    'code': string;
    /**
     * User Email
     * @type {string}
     * @memberof AdminOtpVerifyRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOtpVerifyRequest
     */
    'app'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOtpVerifyRequest
     */
    'appType'?: AdminOtpVerifyRequestAppTypeEnum;
}

export const AdminOtpVerifyRequestAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AdminOtpVerifyRequestAppTypeEnum = typeof AdminOtpVerifyRequestAppTypeEnum[keyof typeof AdminOtpVerifyRequestAppTypeEnum];

/**
 * 
 * @export
 * @interface AdminPasswordResetRequest
 */
export interface AdminPasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminPasswordResetRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface AdminPopulatedAuthorizedAppDto
 */
export interface AdminPopulatedAuthorizedAppDto {
    /**
     * 
     * @type {string}
     * @memberof AdminPopulatedAuthorizedAppDto
     */
    'id': string;
    /**
     * 
     * @type {AdminDto}
     * @memberof AdminPopulatedAuthorizedAppDto
     */
    'admin': AdminDto;
    /**
     * 
     * @type {string}
     * @memberof AdminPopulatedAuthorizedAppDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPopulatedAuthorizedAppDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPopulatedAuthorizedAppDto
     */
    'appType': AdminPopulatedAuthorizedAppDtoAppTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminPopulatedAuthorizedAppDto
     */
    'status': AdminPopulatedAuthorizedAppDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminPopulatedAuthorizedAppDto
     */
    'role': string;
}

export const AdminPopulatedAuthorizedAppDtoAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AdminPopulatedAuthorizedAppDtoAppTypeEnum = typeof AdminPopulatedAuthorizedAppDtoAppTypeEnum[keyof typeof AdminPopulatedAuthorizedAppDtoAppTypeEnum];
export const AdminPopulatedAuthorizedAppDtoStatusEnum = {
    Active: 'active',
    InvitationSent: 'invitationSent'
} as const;

export type AdminPopulatedAuthorizedAppDtoStatusEnum = typeof AdminPopulatedAuthorizedAppDtoStatusEnum[keyof typeof AdminPopulatedAuthorizedAppDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminRegisterRequest
 */
export interface AdminRegisterRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminRegisterRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRegisterRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRegisterRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRegisterRequest
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRegisterRequest
     */
    'appType': AdminRegisterRequestAppTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminRegisterRequest
     */
    'language'?: AdminRegisterRequestLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminRegisterRequest
     */
    'program'?: AdminRegisterRequestProgramEnum;
}

export const AdminRegisterRequestAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AdminRegisterRequestAppTypeEnum = typeof AdminRegisterRequestAppTypeEnum[keyof typeof AdminRegisterRequestAppTypeEnum];
export const AdminRegisterRequestLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type AdminRegisterRequestLanguageEnum = typeof AdminRegisterRequestLanguageEnum[keyof typeof AdminRegisterRequestLanguageEnum];
export const AdminRegisterRequestProgramEnum = {
    Points: 'points',
    Cashback: 'cashback'
} as const;

export type AdminRegisterRequestProgramEnum = typeof AdminRegisterRequestProgramEnum[keyof typeof AdminRegisterRequestProgramEnum];

/**
 * 
 * @export
 * @interface AdminResponse
 */
export interface AdminResponse {
    /**
     * 
     * @type {AdminDto}
     * @memberof AdminResponse
     */
    'admin': AdminDto;
}
/**
 * 
 * @export
 * @interface AdminSignUpRequest
 */
export interface AdminSignUpRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'language': AdminSignUpRequestLanguageEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSignUpRequest
     */
    'roles'?: Array<AdminSignUpRequestRolesEnum>;
    /**
     * 
     * @type {CustomClaimsRequest}
     * @memberof AdminSignUpRequest
     */
    'customClaims'?: CustomClaimsRequest;
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'status'?: AdminSignUpRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'type': AdminSignUpRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'appType': AdminSignUpRequestAppTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSignUpRequest
     */
    'role'?: string;
}

export const AdminSignUpRequestLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type AdminSignUpRequestLanguageEnum = typeof AdminSignUpRequestLanguageEnum[keyof typeof AdminSignUpRequestLanguageEnum];
export const AdminSignUpRequestRolesEnum = {
    SalesRep: 'pos.salesRep',
    SalesAdmin: 'pos.salesAdmin'
} as const;

export type AdminSignUpRequestRolesEnum = typeof AdminSignUpRequestRolesEnum[keyof typeof AdminSignUpRequestRolesEnum];
export const AdminSignUpRequestStatusEnum = {
    Active: 'active',
    ConfirmationSent: 'confirmationSent',
    Locked: 'locked'
} as const;

export type AdminSignUpRequestStatusEnum = typeof AdminSignUpRequestStatusEnum[keyof typeof AdminSignUpRequestStatusEnum];
export const AdminSignUpRequestTypeEnum = {
    InternalLogin: 'internalLogin',
    Normal: 'normal',
    ServiceAccount: 'serviceAccount',
    Group: 'group'
} as const;

export type AdminSignUpRequestTypeEnum = typeof AdminSignUpRequestTypeEnum[keyof typeof AdminSignUpRequestTypeEnum];
export const AdminSignUpRequestAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AdminSignUpRequestAppTypeEnum = typeof AdminSignUpRequestAppTypeEnum[keyof typeof AdminSignUpRequestAppTypeEnum];

/**
 * 
 * @export
 * @interface AdminUpdateRequest
 */
export interface AdminUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateRequest
     */
    'language'?: AdminUpdateRequestLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateRequest
     */
    'lastName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUpdateRequest
     */
    'roles'?: Array<AdminUpdateRequestRolesEnum>;
    /**
     * 
     * @type {CustomClaimsRequest}
     * @memberof AdminUpdateRequest
     */
    'customClaims'?: CustomClaimsRequest;
}

export const AdminUpdateRequestLanguageEnum = {
    En: 'en',
    Es: 'es',
    Pt: 'pt',
    Ar: 'ar'
} as const;

export type AdminUpdateRequestLanguageEnum = typeof AdminUpdateRequestLanguageEnum[keyof typeof AdminUpdateRequestLanguageEnum];
export const AdminUpdateRequestRolesEnum = {
    SalesRep: 'pos.salesRep',
    SalesAdmin: 'pos.salesAdmin'
} as const;

export type AdminUpdateRequestRolesEnum = typeof AdminUpdateRequestRolesEnum[keyof typeof AdminUpdateRequestRolesEnum];

/**
 * 
 * @export
 * @interface AdminsListResponse
 */
export interface AdminsListResponse {
    /**
     * 
     * @type {Array<AdminDto>}
     * @memberof AdminsListResponse
     */
    'admins': Array<AdminDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminsListResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AdminsPopulatedListResponse
 */
export interface AdminsPopulatedListResponse {
    /**
     * 
     * @type {Array<AdminPopulatedAuthorizedAppDto>}
     * @memberof AdminsPopulatedListResponse
     */
    'authorizedAdmins': Array<AdminPopulatedAuthorizedAppDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminsPopulatedListResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AuthorizeRequest
 */
export interface AuthorizeRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizeRequest
     */
    'appId': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizeRequest
     */
    'adminId': string;
    /**
     * 
     * @type {Array<ScopeAuthRequest>}
     * @memberof AuthorizeRequest
     */
    'scope'?: Array<ScopeAuthRequest>;
}
/**
 * 
 * @export
 * @interface AuthorizedAdminResponse
 */
export interface AuthorizedAdminResponse {
    /**
     * 
     * @type {AdminDto}
     * @memberof AuthorizedAdminResponse
     */
    'admin': AdminDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthorizedAdminResponse
     */
    'apps': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAdminResponse
     */
    'access_token': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAdminResponse
     */
    'refresh_token': string;
    /**
     * 
     * @type {Array<AuthorizedAppDto>}
     * @memberof AuthorizedAdminResponse
     */
    'authorizedApps': Array<AuthorizedAppDto>;
}
/**
 * 
 * @export
 * @interface AuthorizedAppDto
 */
export interface AuthorizedAppDto {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppDto
     */
    'admin': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppDto
     */
    'status': AuthorizedAppDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppDto
     */
    'appType': AuthorizedAppDtoAppTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppDto
     */
    'role': string;
}

export const AuthorizedAppDtoStatusEnum = {
    Active: 'active',
    InvitationSent: 'invitationSent'
} as const;

export type AuthorizedAppDtoStatusEnum = typeof AuthorizedAppDtoStatusEnum[keyof typeof AuthorizedAppDtoStatusEnum];
export const AuthorizedAppDtoAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AuthorizedAppDtoAppTypeEnum = typeof AuthorizedAppDtoAppTypeEnum[keyof typeof AuthorizedAppDtoAppTypeEnum];

/**
 * 
 * @export
 * @interface AuthorizedAppRequest
 */
export interface AuthorizedAppRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppRequest
     */
    'appType': AuthorizedAppRequestAppTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppRequest
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppRequest
     */
    'status': AuthorizedAppRequestStatusEnum;
}

export const AuthorizedAppRequestAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;

export type AuthorizedAppRequestAppTypeEnum = typeof AuthorizedAppRequestAppTypeEnum[keyof typeof AuthorizedAppRequestAppTypeEnum];
export const AuthorizedAppRequestStatusEnum = {
    Active: 'active',
    InvitationSent: 'invitationSent'
} as const;

export type AuthorizedAppRequestStatusEnum = typeof AuthorizedAppRequestStatusEnum[keyof typeof AuthorizedAppRequestStatusEnum];

/**
 * 
 * @export
 * @interface AuthorizedAppResponse
 */
export interface AuthorizedAppResponse {
    /**
     * 
     * @type {AuthorizedAppDto}
     * @memberof AuthorizedAppResponse
     */
    'authorizedApp': AuthorizedAppDto;
}
/**
 * 
 * @export
 * @interface AuthorizedAppUpdateRequest
 */
export interface AuthorizedAppUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppUpdateRequest
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorizedAppUpdateRequest
     */
    'status'?: AuthorizedAppUpdateRequestStatusEnum;
}

export const AuthorizedAppUpdateRequestStatusEnum = {
    Active: 'active',
    InvitationSent: 'invitationSent'
} as const;

export type AuthorizedAppUpdateRequestStatusEnum = typeof AuthorizedAppUpdateRequestStatusEnum[keyof typeof AuthorizedAppUpdateRequestStatusEnum];

/**
 * 
 * @export
 * @interface BulkAdminsRequest
 */
export interface BulkAdminsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkAdminsRequest
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateServiceAccountResponse
 */
export interface CreateServiceAccountResponse {
    /**
     * 
     * @type {ServiceAccountDto}
     * @memberof CreateServiceAccountResponse
     */
    'serviceAccount': ServiceAccountDto;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceAccountResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface CustomClaimsDto
 */
export interface CustomClaimsDto {
    /**
     * 
     * @type {string}
     * @memberof CustomClaimsDto
     */
    'branch'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomClaimsDto
     */
    'brand'?: string;
}
/**
 * 
 * @export
 * @interface CustomClaimsRequest
 */
export interface CustomClaimsRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomClaimsRequest
     */
    'branch': string;
    /**
     * 
     * @type {string}
     * @memberof CustomClaimsRequest
     */
    'brand': string;
}
/**
 * 
 * @export
 * @interface ListServiceAccountsResponse
 */
export interface ListServiceAccountsResponse {
    /**
     * 
     * @type {Array<ServiceAccountDto>}
     * @memberof ListServiceAccountsResponse
     */
    'serviceAccounts': Array<ServiceAccountDto>;
    /**
     * 
     * @type {number}
     * @memberof ListServiceAccountsResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface RefreshRequest
 */
export interface RefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshRequest
     */
    'refresh_token'?: string;
}
/**
 * 
 * @export
 * @interface Resend2FAOtpResponse
 */
export interface Resend2FAOtpResponse {
    /**
     * 
     * @type {AccessLogResponse}
     * @memberof Resend2FAOtpResponse
     */
    'accessLog'?: AccessLogResponse;
}
/**
 * 
 * @export
 * @interface RolesCreateRequest
 */
export interface RolesCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof RolesCreateRequest
     */
    'key': RolesCreateRequestKeyEnum;
    /**
     * 
     * @type {object}
     * @memberof RolesCreateRequest
     */
    'name'?: object;
    /**
     * 
     * @type {object}
     * @memberof RolesCreateRequest
     */
    'description'?: object;
}

export const RolesCreateRequestKeyEnum = {
    Admin: 'admin',
    Manager: 'manager',
    Marketing: 'marketing',
    Analyst: 'analyst',
    CustomerSupport: 'customerSupport',
    Accounting: 'accounting',
    SalesRep: 'salesRep',
    SalesRepGroup: 'salesRepGroup'
} as const;

export type RolesCreateRequestKeyEnum = typeof RolesCreateRequestKeyEnum[keyof typeof RolesCreateRequestKeyEnum];

/**
 * 
 * @export
 * @interface ScopeAuthRequest
 */
export interface ScopeAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof ScopeAuthRequest
     */
    'action': ScopeAuthRequestActionEnum;
    /**
     * 
     * @type {string}
     * @memberof ScopeAuthRequest
     */
    'resource': string;
    /**
     * 
     * @type {string}
     * @memberof ScopeAuthRequest
     */
    'service': ScopeAuthRequestServiceEnum;
}

export const ScopeAuthRequestActionEnum = {
    Read: 'read',
    Edit: 'edit',
    Write: 'write'
} as const;

export type ScopeAuthRequestActionEnum = typeof ScopeAuthRequestActionEnum[keyof typeof ScopeAuthRequestActionEnum];
export const ScopeAuthRequestServiceEnum = {
    Analytics: 'analytics',
    Challenges: 'challenges',
    Core: 'core',
    Ecommerce: 'ecommerce',
    Events: 'events',
    Frontend: 'frontend',
    Games: 'games',
    Integrations: 'integrations',
    Notifications: 'notifications',
    Subscriptions: 'subscriptions',
    Monitor: 'monitor',
    Security: 'security'
} as const;

export type ScopeAuthRequestServiceEnum = typeof ScopeAuthRequestServiceEnum[keyof typeof ScopeAuthRequestServiceEnum];

/**
 * 
 * @export
 * @interface ServiceAccountDto
 */
export interface ServiceAccountDto {
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDto
     */
    'app': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDto
     */
    'admin': string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDto
     */
    'key': string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceAccountDto
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof ServiceAccountDto
     */
    'createdBy': string;
}
/**
 * 
 * @export
 * @interface TermsAcceptanceResponse
 */
export interface TermsAcceptanceResponse {
    /**
     * Whether the admin has accepted the Terms of Service
     * @type {boolean}
     * @memberof TermsAcceptanceResponse
     */
    'accepted': boolean;
    /**
     * Date when the terms were accepted
     * @type {string}
     * @memberof TermsAcceptanceResponse
     */
    'acceptedAt'?: string;
}
/**
 * 
 * @export
 * @interface TermsDto
 */
export interface TermsDto {
    /**
     * Indicates if the admin has accepted the Terms of Service
     * @type {boolean}
     * @memberof TermsDto
     */
    'accepted'?: boolean;
    /**
     * Date when the admin accepted the Terms of Service
     * @type {string}
     * @memberof TermsDto
     */
    'acceptedAt'?: string;
    /**
     * Version of the Terms of Service that was accepted
     * @type {string}
     * @memberof TermsDto
     */
    'version'?: string;
    /**
     * IP address from which the Terms of Service was accepted
     * @type {string}
     * @memberof TermsDto
     */
    'ipAddress'?: string;
}
/**
 * 
 * @export
 * @interface Verify2FAOtpRequest
 */
export interface Verify2FAOtpRequest {
    /**
     * The One-Time Password sent in the email
     * @type {string}
     * @memberof Verify2FAOtpRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface Verify2FAOtpResponse
 */
export interface Verify2FAOtpResponse {
    /**
     * 
     * @type {AuthorizedAdminResponse}
     * @memberof Verify2FAOtpResponse
     */
    'authorizedAdmin'?: AuthorizedAdminResponse;
    /**
     * 
     * @type {AccessLogResponse}
     * @memberof Verify2FAOtpResponse
     */
    'accessLog'?: AccessLogResponse;
}

/**
 * AdminsApi - axios parameter creator
 * @export
 */
export const AdminsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary accept invite
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerAcceptInvite: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerAcceptInvite', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminsControllerAcceptInvite', 'id', id)
            const localVarPath = `/v2/admins/{id}/invite/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authorize Admin
         * @param {AdminsControllerAuthorizeAppTypeEnum} [appType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerAuthorize: async (appType?: AdminsControllerAuthorizeAppTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admins/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appType !== undefined) {
                localVarQueryParameter['appType'] = appType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if admin has accepted Terms of Service
         * @param {string} email Admin email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCheckTermsAcceptance: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('adminsControllerCheckTermsAcceptance', 'email', email)
            const localVarPath = `/v2/admins/terms-acceptance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin sign-up
         * @param {string} gamixAppId 
         * @param {AdminSignUpRequest} adminSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCreate: async (gamixAppId: string, adminSignUpRequest: AdminSignUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminSignUpRequest' is not null or undefined
            assertParamExists('adminsControllerCreate', 'adminSignUpRequest', adminSignUpRequest)
            const localVarPath = `/v2/admins/sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSignUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This api sends a confirmation email to help verify the users identity
         * @param {AdminOtpRegisterRequest} adminOtpRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCreateWithOtp: async (adminOtpRegisterRequest: AdminOtpRegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminOtpRegisterRequest' is not null or undefined
            assertParamExists('adminsControllerCreateWithOtp', 'adminOtpRegisterRequest', adminOtpRegisterRequest)
            const localVarPath = `/v2/admins/set-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOtpRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get admin access log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerGetAccessLog: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admins/access-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication pending2FAToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Invite
         * @param {string} gamixAppId 
         * @param {AdminInviteRequest} adminInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerInvite: async (gamixAppId: string, adminInviteRequest: AdminInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerInvite', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminInviteRequest' is not null or undefined
            assertParamExists('adminsControllerInvite', 'adminInviteRequest', adminInviteRequest)
            const localVarPath = `/v2/admins/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInviteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list admins
         * @param {string} gamixAppId 
         * @param {Array<AdminsControllerListAppTypeEnum>} [appType] 
         * @param {AdminsControllerListRoleEnum} [role] 
         * @param {string} [email] 
         * @param {Array<AdminsControllerListTypeEnum>} [type] 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerList: async (gamixAppId: string, appType?: Array<AdminsControllerListAppTypeEnum>, role?: AdminsControllerListRoleEnum, email?: string, type?: Array<AdminsControllerListTypeEnum>, search?: string, limit?: number, skip?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (appType) {
                localVarQueryParameter['appType'] = appType;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (type) {
                localVarQueryParameter['type'] = type;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List bulk admins
         * @param {string} gamixAppId 
         * @param {BulkAdminsRequest} bulkAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerListBulk: async (gamixAppId: string, bulkAdminsRequest: BulkAdminsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerListBulk', 'gamixAppId', gamixAppId)
            // verify required parameter 'bulkAdminsRequest' is not null or undefined
            assertParamExists('adminsControllerListBulk', 'bulkAdminsRequest', bulkAdminsRequest)
            const localVarPath = `/v2/admins/bulk-get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAdminsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin Login
         * @param {AdminLoginRequest} adminLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerLogin: async (adminLoginRequest: AdminLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminLoginRequest' is not null or undefined
            assertParamExists('adminsControllerLogin', 'adminLoginRequest', adminLoginRequest)
            const localVarPath = `/v2/admins/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary This api logs out an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admins/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register new admin without apps
         * @param {AdminRegisterRequest} adminRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerRegister: async (adminRegisterRequest: AdminRegisterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminRegisterRequest' is not null or undefined
            assertParamExists('adminsControllerRegister', 'adminRegisterRequest', adminRegisterRequest)
            const localVarPath = `/v2/admins/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRegisterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend 2FA OTP code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerResend2FACode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/admins/resend2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication pending2FAToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary send reset password email
         * @param {string} gamixAppId 
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerResetPassword: async (gamixAppId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerResetPassword', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminPasswordResetRequest' is not null or undefined
            assertParamExists('adminsControllerResetPassword', 'adminPasswordResetRequest', adminPasswordResetRequest)
            const localVarPath = `/v2/admins/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary revoke an app from an admin
         * @param {string} gamixAppId 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerRevoke: async (gamixAppId: string, adminId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerRevoke', 'gamixAppId', gamixAppId)
            // verify required parameter 'adminId' is not null or undefined
            assertParamExists('adminsControllerRevoke', 'adminId', adminId)
            const localVarPath = `/v2/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (adminId !== undefined) {
                localVarQueryParameter['adminId'] = adminId;
            }

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Admin
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdate: async (adminUpdateRequest: AdminUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpdateRequest' is not null or undefined
            assertParamExists('adminsControllerUpdate', 'adminUpdateRequest', adminUpdateRequest)
            const localVarPath = `/v2/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Other Admins
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdateById: async (gamixAppId: string, id: string, adminUpdateRequest: AdminUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('adminsControllerUpdateById', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminsControllerUpdateById', 'id', id)
            // verify required parameter 'adminUpdateRequest' is not null or undefined
            assertParamExists('adminsControllerUpdateById', 'adminUpdateRequest', adminUpdateRequest)
            const localVarPath = `/v2/admins/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change password
         * @param {AdminInviteSetupRequest} adminInviteSetupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdatePassword: async (adminInviteSetupRequest: AdminInviteSetupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminInviteSetupRequest' is not null or undefined
            assertParamExists('adminsControllerUpdatePassword', 'adminInviteSetupRequest', adminInviteSetupRequest)
            const localVarPath = `/v2/admins/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminInviteSetupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify new admin registration
         * @param {string} bin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerify: async (bin: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bin' is not null or undefined
            assertParamExists('adminsControllerVerify', 'bin', bin)
            const localVarPath = `/v2/admins/verify/{bin}`
                .replace(`{${"bin"}}`, encodeURIComponent(String(bin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify 2FA OTP
         * @param {Verify2FAOtpRequest} verify2FAOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerifyAdminLoginOtp: async (verify2FAOtpRequest: Verify2FAOtpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verify2FAOtpRequest' is not null or undefined
            assertParamExists('adminsControllerVerifyAdminLoginOtp', 'verify2FAOtpRequest', verify2FAOtpRequest)
            const localVarPath = `/v2/admins/verify2fa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication pending2FAToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verify2FAOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify your email through the link sent to your mail to complete registration
         * @param {AdminOtpVerifyRequest} adminOtpVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerifyAdminOtp: async (adminOtpVerifyRequest: AdminOtpVerifyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminOtpVerifyRequest' is not null or undefined
            assertParamExists('adminsControllerVerifyAdminOtp', 'adminOtpVerifyRequest', adminOtpVerifyRequest)
            const localVarPath = `/v2/admins/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOtpVerifyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminsApi - functional programming interface
 * @export
 */
export const AdminsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary accept invite
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerAcceptInvite(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerAcceptInvite(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerAcceptInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Authorize Admin
         * @param {AdminsControllerAuthorizeAppTypeEnum} [appType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerAuthorize(appType?: AdminsControllerAuthorizeAppTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAppsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerAuthorize(appType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerAuthorize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if admin has accepted Terms of Service
         * @param {string} email Admin email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerCheckTermsAcceptance(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TermsAcceptanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerCheckTermsAcceptance(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerCheckTermsAcceptance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin sign-up
         * @param {string} gamixAppId 
         * @param {AdminSignUpRequest} adminSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerCreate(gamixAppId: string, adminSignUpRequest: AdminSignUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerCreate(gamixAppId, adminSignUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary This api sends a confirmation email to help verify the users identity
         * @param {AdminOtpRegisterRequest} adminOtpRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerCreateWithOtp(adminOtpRegisterRequest: AdminOtpRegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerCreateWithOtp(adminOtpRegisterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerCreateWithOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get admin access log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerGetAccessLog(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessLogResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerGetAccessLog(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerGetAccessLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Invite
         * @param {string} gamixAppId 
         * @param {AdminInviteRequest} adminInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerInvite(gamixAppId: string, adminInviteRequest: AdminInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerInvite(gamixAppId, adminInviteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list admins
         * @param {string} gamixAppId 
         * @param {Array<AdminsControllerListAppTypeEnum>} [appType] 
         * @param {AdminsControllerListRoleEnum} [role] 
         * @param {string} [email] 
         * @param {Array<AdminsControllerListTypeEnum>} [type] 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerList(gamixAppId: string, appType?: Array<AdminsControllerListAppTypeEnum>, role?: AdminsControllerListRoleEnum, email?: string, type?: Array<AdminsControllerListTypeEnum>, search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsPopulatedListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerList(gamixAppId, appType, role, email, type, search, limit, skip, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List bulk admins
         * @param {string} gamixAppId 
         * @param {BulkAdminsRequest} bulkAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerListBulk(gamixAppId: string, bulkAdminsRequest: BulkAdminsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerListBulk(gamixAppId, bulkAdminsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerListBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Admin Login
         * @param {AdminLoginRequest} adminLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerLogin(adminLoginRequest: AdminLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerLogin(adminLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary This api logs out an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerLogout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register new admin without apps
         * @param {AdminRegisterRequest} adminRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerRegister(adminRegisterRequest: AdminRegisterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerRegister(adminRegisterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerRegister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resend 2FA OTP code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerResend2FACode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resend2FAOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerResend2FACode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerResend2FACode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary send reset password email
         * @param {string} gamixAppId 
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerResetPassword(gamixAppId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerResetPassword(gamixAppId, adminPasswordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerResetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary revoke an app from an admin
         * @param {string} gamixAppId 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerRevoke(gamixAppId: string, adminId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerRevoke(gamixAppId, adminId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerRevoke']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Admin
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerUpdate(adminUpdateRequest: AdminUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerUpdate(adminUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Other Admins
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerUpdateById(gamixAppId: string, id: string, adminUpdateRequest: AdminUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerUpdateById(gamixAppId, id, adminUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerUpdateById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change password
         * @param {AdminInviteSetupRequest} adminInviteSetupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerUpdatePassword(adminInviteSetupRequest: AdminInviteSetupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerUpdatePassword(adminInviteSetupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerUpdatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify new admin registration
         * @param {string} bin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerVerify(bin: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerVerify(bin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify 2FA OTP
         * @param {Verify2FAOtpRequest} verify2FAOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerVerifyAdminLoginOtp(verify2FAOtpRequest: Verify2FAOtpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Verify2FAOtpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerVerifyAdminLoginOtp(verify2FAOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerVerifyAdminLoginOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify your email through the link sent to your mail to complete registration
         * @param {AdminOtpVerifyRequest} adminOtpVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminsControllerVerifyAdminOtp(adminOtpVerifyRequest: AdminOtpVerifyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminsControllerVerifyAdminOtp(adminOtpVerifyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminsApi.adminsControllerVerifyAdminOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminsApi - factory interface
 * @export
 */
export const AdminsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminsApiFp(configuration)
    return {
        /**
         * 
         * @summary accept invite
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerAcceptInvite(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminsControllerAcceptInvite(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authorize Admin
         * @param {AdminsControllerAuthorizeAppTypeEnum} [appType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerAuthorize(appType?: AdminsControllerAuthorizeAppTypeEnum, options?: any): AxiosPromise<AdminAppsResponse> {
            return localVarFp.adminsControllerAuthorize(appType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if admin has accepted Terms of Service
         * @param {string} email Admin email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCheckTermsAcceptance(email: string, options?: any): AxiosPromise<TermsAcceptanceResponse> {
            return localVarFp.adminsControllerCheckTermsAcceptance(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin sign-up
         * @param {string} gamixAppId 
         * @param {AdminSignUpRequest} adminSignUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCreate(gamixAppId: string, adminSignUpRequest: AdminSignUpRequest, options?: any): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerCreate(gamixAppId, adminSignUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This api sends a confirmation email to help verify the users identity
         * @param {AdminOtpRegisterRequest} adminOtpRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerCreateWithOtp(adminOtpRegisterRequest: AdminOtpRegisterRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsControllerCreateWithOtp(adminOtpRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get admin access log
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerGetAccessLog(options?: any): AxiosPromise<AccessLogResponse> {
            return localVarFp.adminsControllerGetAccessLog(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Invite
         * @param {string} gamixAppId 
         * @param {AdminInviteRequest} adminInviteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerInvite(gamixAppId: string, adminInviteRequest: AdminInviteRequest, options?: any): AxiosPromise<AdminInviteResponse> {
            return localVarFp.adminsControllerInvite(gamixAppId, adminInviteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list admins
         * @param {string} gamixAppId 
         * @param {Array<AdminsControllerListAppTypeEnum>} [appType] 
         * @param {AdminsControllerListRoleEnum} [role] 
         * @param {string} [email] 
         * @param {Array<AdminsControllerListTypeEnum>} [type] 
         * @param {string} [search] 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerList(gamixAppId: string, appType?: Array<AdminsControllerListAppTypeEnum>, role?: AdminsControllerListRoleEnum, email?: string, type?: Array<AdminsControllerListTypeEnum>, search?: string, limit?: number, skip?: number, options?: any): AxiosPromise<AdminsPopulatedListResponse> {
            return localVarFp.adminsControllerList(gamixAppId, appType, role, email, type, search, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List bulk admins
         * @param {string} gamixAppId 
         * @param {BulkAdminsRequest} bulkAdminsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerListBulk(gamixAppId: string, bulkAdminsRequest: BulkAdminsRequest, options?: any): AxiosPromise<AdminsListResponse> {
            return localVarFp.adminsControllerListBulk(gamixAppId, bulkAdminsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin Login
         * @param {AdminLoginRequest} adminLoginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerLogin(adminLoginRequest: AdminLoginRequest, options?: any): AxiosPromise<AdminLoginResponse> {
            return localVarFp.adminsControllerLogin(adminLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary This api logs out an admin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerLogout(options?: any): AxiosPromise<void> {
            return localVarFp.adminsControllerLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register new admin without apps
         * @param {AdminRegisterRequest} adminRegisterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerRegister(adminRegisterRequest: AdminRegisterRequest, options?: any): AxiosPromise<AdminResponse> {
            return localVarFp.adminsControllerRegister(adminRegisterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend 2FA OTP code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerResend2FACode(options?: any): AxiosPromise<Resend2FAOtpResponse> {
            return localVarFp.adminsControllerResend2FACode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary send reset password email
         * @param {string} gamixAppId 
         * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerResetPassword(gamixAppId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options?: any): AxiosPromise<void> {
            return localVarFp.adminsControllerResetPassword(gamixAppId, adminPasswordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary revoke an app from an admin
         * @param {string} gamixAppId 
         * @param {string} adminId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerRevoke(gamixAppId: string, adminId: string, options?: any): AxiosPromise<void> {
            return localVarFp.adminsControllerRevoke(gamixAppId, adminId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Admin
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdate(adminUpdateRequest: AdminUpdateRequest, options?: any): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerUpdate(adminUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Other Admins
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {AdminUpdateRequest} adminUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdateById(gamixAppId: string, id: string, adminUpdateRequest: AdminUpdateRequest, options?: any): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerUpdateById(gamixAppId, id, adminUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change password
         * @param {AdminInviteSetupRequest} adminInviteSetupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerUpdatePassword(adminInviteSetupRequest: AdminInviteSetupRequest, options?: any): AxiosPromise<AdminResponse> {
            return localVarFp.adminsControllerUpdatePassword(adminInviteSetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify new admin registration
         * @param {string} bin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerify(bin: string, options?: any): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerVerify(bin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify 2FA OTP
         * @param {Verify2FAOtpRequest} verify2FAOtpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerifyAdminLoginOtp(verify2FAOtpRequest: Verify2FAOtpRequest, options?: any): AxiosPromise<Verify2FAOtpResponse> {
            return localVarFp.adminsControllerVerifyAdminLoginOtp(verify2FAOtpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify your email through the link sent to your mail to complete registration
         * @param {AdminOtpVerifyRequest} adminOtpVerifyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminsControllerVerifyAdminOtp(adminOtpVerifyRequest: AdminOtpVerifyRequest, options?: any): AxiosPromise<AuthorizedAdminResponse> {
            return localVarFp.adminsControllerVerifyAdminOtp(adminOtpVerifyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminsApi - object-oriented interface
 * @export
 * @class AdminsApi
 * @extends {BaseAPI}
 */
export class AdminsApi extends BaseAPI {
    /**
     * 
     * @summary accept invite
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerAcceptInvite(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerAcceptInvite(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authorize Admin
     * @param {AdminsControllerAuthorizeAppTypeEnum} [appType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerAuthorize(appType?: AdminsControllerAuthorizeAppTypeEnum, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerAuthorize(appType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if admin has accepted Terms of Service
     * @param {string} email Admin email address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerCheckTermsAcceptance(email: string, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerCheckTermsAcceptance(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin sign-up
     * @param {string} gamixAppId 
     * @param {AdminSignUpRequest} adminSignUpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerCreate(gamixAppId: string, adminSignUpRequest: AdminSignUpRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerCreate(gamixAppId, adminSignUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This api sends a confirmation email to help verify the users identity
     * @param {AdminOtpRegisterRequest} adminOtpRegisterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerCreateWithOtp(adminOtpRegisterRequest: AdminOtpRegisterRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerCreateWithOtp(adminOtpRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get admin access log
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerGetAccessLog(options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerGetAccessLog(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Invite
     * @param {string} gamixAppId 
     * @param {AdminInviteRequest} adminInviteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerInvite(gamixAppId: string, adminInviteRequest: AdminInviteRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerInvite(gamixAppId, adminInviteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list admins
     * @param {string} gamixAppId 
     * @param {Array<AdminsControllerListAppTypeEnum>} [appType] 
     * @param {AdminsControllerListRoleEnum} [role] 
     * @param {string} [email] 
     * @param {Array<AdminsControllerListTypeEnum>} [type] 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerList(gamixAppId: string, appType?: Array<AdminsControllerListAppTypeEnum>, role?: AdminsControllerListRoleEnum, email?: string, type?: Array<AdminsControllerListTypeEnum>, search?: string, limit?: number, skip?: number, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerList(gamixAppId, appType, role, email, type, search, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List bulk admins
     * @param {string} gamixAppId 
     * @param {BulkAdminsRequest} bulkAdminsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerListBulk(gamixAppId: string, bulkAdminsRequest: BulkAdminsRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerListBulk(gamixAppId, bulkAdminsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin Login
     * @param {AdminLoginRequest} adminLoginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerLogin(adminLoginRequest: AdminLoginRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerLogin(adminLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary This api logs out an admin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerLogout(options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register new admin without apps
     * @param {AdminRegisterRequest} adminRegisterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerRegister(adminRegisterRequest: AdminRegisterRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerRegister(adminRegisterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend 2FA OTP code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerResend2FACode(options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerResend2FACode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary send reset password email
     * @param {string} gamixAppId 
     * @param {AdminPasswordResetRequest} adminPasswordResetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerResetPassword(gamixAppId: string, adminPasswordResetRequest: AdminPasswordResetRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerResetPassword(gamixAppId, adminPasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary revoke an app from an admin
     * @param {string} gamixAppId 
     * @param {string} adminId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerRevoke(gamixAppId: string, adminId: string, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerRevoke(gamixAppId, adminId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Admin
     * @param {AdminUpdateRequest} adminUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerUpdate(adminUpdateRequest: AdminUpdateRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerUpdate(adminUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Other Admins
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {AdminUpdateRequest} adminUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerUpdateById(gamixAppId: string, id: string, adminUpdateRequest: AdminUpdateRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerUpdateById(gamixAppId, id, adminUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change password
     * @param {AdminInviteSetupRequest} adminInviteSetupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerUpdatePassword(adminInviteSetupRequest: AdminInviteSetupRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerUpdatePassword(adminInviteSetupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify new admin registration
     * @param {string} bin 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerVerify(bin: string, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerVerify(bin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify 2FA OTP
     * @param {Verify2FAOtpRequest} verify2FAOtpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerVerifyAdminLoginOtp(verify2FAOtpRequest: Verify2FAOtpRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerVerifyAdminLoginOtp(verify2FAOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify your email through the link sent to your mail to complete registration
     * @param {AdminOtpVerifyRequest} adminOtpVerifyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsApi
     */
    public adminsControllerVerifyAdminOtp(adminOtpVerifyRequest: AdminOtpVerifyRequest, options?: RawAxiosRequestConfig) {
        return AdminsApiFp(this.configuration).adminsControllerVerifyAdminOtp(adminOtpVerifyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminsControllerAuthorizeAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;
export type AdminsControllerAuthorizeAppTypeEnum = typeof AdminsControllerAuthorizeAppTypeEnum[keyof typeof AdminsControllerAuthorizeAppTypeEnum];
/**
 * @export
 */
export const AdminsControllerListAppTypeEnum = {
    CoreLoyalty: 'coreLoyalty',
    CoreTeams: 'coreTeams',
    Pos: 'POS',
    Fisico: 'fisico',
    Games: 'games',
    Advertiser: 'advertiser',
    Retailer: 'retailer'
} as const;
export type AdminsControllerListAppTypeEnum = typeof AdminsControllerListAppTypeEnum[keyof typeof AdminsControllerListAppTypeEnum];
/**
 * @export
 */
export const AdminsControllerListRoleEnum = {
    SalesRep: 'pos.salesRep',
    SalesAdmin: 'pos.salesAdmin'
} as const;
export type AdminsControllerListRoleEnum = typeof AdminsControllerListRoleEnum[keyof typeof AdminsControllerListRoleEnum];
/**
 * @export
 */
export const AdminsControllerListTypeEnum = {
    InternalLogin: 'internalLogin',
    Normal: 'normal',
    ServiceAccount: 'serviceAccount',
    Group: 'group'
} as const;
export type AdminsControllerListTypeEnum = typeof AdminsControllerListTypeEnum[keyof typeof AdminsControllerListTypeEnum];


/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AuthorizeRequest} authorizeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerAuthorize: async (authorizeRequest: AuthorizeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorizeRequest' is not null or undefined
            assertParamExists('authenticationControllerAuthorize', 'authorizeRequest', authorizeRequest)
            const localVarPath = `/v2/authentication/authorize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {RefreshRequest} refreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerRefreshToken: async (gamixAppId: string, refreshRequest: RefreshRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('authenticationControllerRefreshToken', 'gamixAppId', gamixAppId)
            // verify required parameter 'refreshRequest' is not null or undefined
            assertParamExists('authenticationControllerRefreshToken', 'refreshRequest', refreshRequest)
            const localVarPath = `/v2/authentication/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AuthorizeRequest} authorizeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationControllerAuthorize(authorizeRequest: AuthorizeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationControllerAuthorize(authorizeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authenticationControllerAuthorize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {RefreshRequest} refreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticationControllerRefreshToken(gamixAppId: string, refreshRequest: RefreshRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticationControllerRefreshToken(gamixAppId, refreshRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.authenticationControllerRefreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @param {AuthorizeRequest} authorizeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerAuthorize(authorizeRequest: AuthorizeRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authenticationControllerAuthorize(authorizeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} gamixAppId 
         * @param {RefreshRequest} refreshRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticationControllerRefreshToken(gamixAppId: string, refreshRequest: RefreshRequest, options?: any): AxiosPromise<void> {
            return localVarFp.authenticationControllerRefreshToken(gamixAppId, refreshRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @param {AuthorizeRequest} authorizeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationControllerAuthorize(authorizeRequest: AuthorizeRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authenticationControllerAuthorize(authorizeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} gamixAppId 
     * @param {RefreshRequest} refreshRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authenticationControllerRefreshToken(gamixAppId: string, refreshRequest: RefreshRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authenticationControllerRefreshToken(gamixAppId, refreshRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthorizedAppsApi - axios parameter creator
 * @export
 */
export const AuthorizedAppsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary grant App to an Admin
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppRequest} authorizedAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerCreate: async (gamixAppId: string, admin: string, authorizedAppRequest: AuthorizedAppRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('authorizedAppsControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('authorizedAppsControllerCreate', 'admin', admin)
            // verify required parameter 'authorizedAppRequest' is not null or undefined
            assertParamExists('authorizedAppsControllerCreate', 'authorizedAppRequest', authorizedAppRequest)
            const localVarPath = `/v2/authorized-apps/{admin}/grant`
                .replace(`{${"admin"}}`, encodeURIComponent(String(admin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizedAppRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update admin\'s app role
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppUpdateRequest} authorizedAppUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerUpdate: async (gamixAppId: string, admin: string, authorizedAppUpdateRequest: AuthorizedAppUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('authorizedAppsControllerUpdate', 'gamixAppId', gamixAppId)
            // verify required parameter 'admin' is not null or undefined
            assertParamExists('authorizedAppsControllerUpdate', 'admin', admin)
            // verify required parameter 'authorizedAppUpdateRequest' is not null or undefined
            assertParamExists('authorizedAppsControllerUpdate', 'authorizedAppUpdateRequest', authorizedAppUpdateRequest)
            const localVarPath = `/v2/authorized-apps/{admin}`
                .replace(`{${"admin"}}`, encodeURIComponent(String(admin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authorizedAppUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizedAppsApi - functional programming interface
 * @export
 */
export const AuthorizedAppsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizedAppsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary grant App to an Admin
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppRequest} authorizedAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizedAppsControllerCreate(gamixAppId: string, admin: string, authorizedAppRequest: AuthorizedAppRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizedAppsControllerCreate(gamixAppId, admin, authorizedAppRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizedAppsApi.authorizedAppsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update admin\'s app role
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppUpdateRequest} authorizedAppUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorizedAppsControllerUpdate(gamixAppId: string, admin: string, authorizedAppUpdateRequest: AuthorizedAppUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorizedAppResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorizedAppsControllerUpdate(gamixAppId, admin, authorizedAppUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizedAppsApi.authorizedAppsControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthorizedAppsApi - factory interface
 * @export
 */
export const AuthorizedAppsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizedAppsApiFp(configuration)
    return {
        /**
         * 
         * @summary grant App to an Admin
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppRequest} authorizedAppRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerCreate(gamixAppId: string, admin: string, authorizedAppRequest: AuthorizedAppRequest, options?: any): AxiosPromise<AuthorizedAppResponse> {
            return localVarFp.authorizedAppsControllerCreate(gamixAppId, admin, authorizedAppRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update admin\'s app role
         * @param {string} gamixAppId 
         * @param {string} admin 
         * @param {AuthorizedAppUpdateRequest} authorizedAppUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorizedAppsControllerUpdate(gamixAppId: string, admin: string, authorizedAppUpdateRequest: AuthorizedAppUpdateRequest, options?: any): AxiosPromise<AuthorizedAppResponse> {
            return localVarFp.authorizedAppsControllerUpdate(gamixAppId, admin, authorizedAppUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthorizedAppsApi - object-oriented interface
 * @export
 * @class AuthorizedAppsApi
 * @extends {BaseAPI}
 */
export class AuthorizedAppsApi extends BaseAPI {
    /**
     * 
     * @summary grant App to an Admin
     * @param {string} gamixAppId 
     * @param {string} admin 
     * @param {AuthorizedAppRequest} authorizedAppRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizedAppsApi
     */
    public authorizedAppsControllerCreate(gamixAppId: string, admin: string, authorizedAppRequest: AuthorizedAppRequest, options?: RawAxiosRequestConfig) {
        return AuthorizedAppsApiFp(this.configuration).authorizedAppsControllerCreate(gamixAppId, admin, authorizedAppRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update admin\'s app role
     * @param {string} gamixAppId 
     * @param {string} admin 
     * @param {AuthorizedAppUpdateRequest} authorizedAppUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizedAppsApi
     */
    public authorizedAppsControllerUpdate(gamixAppId: string, admin: string, authorizedAppUpdateRequest: AuthorizedAppUpdateRequest, options?: RawAxiosRequestConfig) {
        return AuthorizedAppsApiFp(this.configuration).authorizedAppsControllerUpdate(gamixAppId, admin, authorizedAppUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityControllerHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityControllerHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.securityControllerHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.securityControllerHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityControllerHealthCheck(options?: any): AxiosPromise<void> {
            return localVarFp.securityControllerHealthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public securityControllerHealthCheck(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).securityControllerHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RolesApi - axios parameter creator
 * @export
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a role
         * @param {string} gamixAppId 
         * @param {RolesCreateRequest} rolesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerCreate: async (gamixAppId: string, rolesCreateRequest: RolesCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('rolesControllerCreate', 'gamixAppId', gamixAppId)
            // verify required parameter 'rolesCreateRequest' is not null or undefined
            assertParamExists('rolesControllerCreate', 'rolesCreateRequest', rolesCreateRequest)
            const localVarPath = `/v2/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rolesCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get role by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rolesControllerGet', 'id', id)
            const localVarPath = `/v2/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 * @export
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create a role
         * @param {string} gamixAppId 
         * @param {RolesCreateRequest} rolesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerCreate(gamixAppId: string, rolesCreateRequest: RolesCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerCreate(gamixAppId, rolesCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get role by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesApi - factory interface
 * @export
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * 
         * @summary create a role
         * @param {string} gamixAppId 
         * @param {RolesCreateRequest} rolesCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerCreate(gamixAppId: string, rolesCreateRequest: RolesCreateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.rolesControllerCreate(gamixAppId, rolesCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get role by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.rolesControllerGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerList(options?: any): AxiosPromise<void> {
            return localVarFp.rolesControllerList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
export class RolesApi extends BaseAPI {
    /**
     * 
     * @summary create a role
     * @param {string} gamixAppId 
     * @param {RolesCreateRequest} rolesCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public rolesControllerCreate(gamixAppId: string, rolesCreateRequest: RolesCreateRequest, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesControllerCreate(gamixAppId, rolesCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get role by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public rolesControllerGet(id: string, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesControllerGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    public rolesControllerList(options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesControllerList(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceAccountsApi - axios parameter creator
 * @export
 */
export const ServiceAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new service account
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAccountsControllerCreate: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('serviceAccountsControllerCreate', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/service-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Service Account
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAccountsControllerDelete: async (gamixAppId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('serviceAccountsControllerDelete', 'gamixAppId', gamixAppId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('serviceAccountsControllerDelete', 'id', id)
            const localVarPath = `/v2/service-accounts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Service Accounts
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAccountsControllerList: async (gamixAppId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gamixAppId' is not null or undefined
            assertParamExists('serviceAccountsControllerList', 'gamixAppId', gamixAppId)
            const localVarPath = `/v2/service-accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication serviceAccountHeader required
            await setApiKeyToObject(localVarHeaderParameter, "x-coretava-access-token", configuration)

            // authentication adminToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gamixAppId != null) {
                localVarHeaderParameter['gamix-app-id'] = String(gamixAppId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceAccountsApi - functional programming interface
 * @export
 */
export const ServiceAccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceAccountsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create new service account
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceAccountsControllerCreate(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateServiceAccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceAccountsControllerCreate(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceAccountsApi.serviceAccountsControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Service Account
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceAccountsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceAccountsControllerDelete(gamixAppId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceAccountsApi.serviceAccountsControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Service Accounts
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async serviceAccountsControllerList(gamixAppId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListServiceAccountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.serviceAccountsControllerList(gamixAppId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceAccountsApi.serviceAccountsControllerList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceAccountsApi - factory interface
 * @export
 */
export const ServiceAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceAccountsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create new service account
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAccountsControllerCreate(gamixAppId: string, options?: any): AxiosPromise<CreateServiceAccountResponse> {
            return localVarFp.serviceAccountsControllerCreate(gamixAppId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Service Account
         * @param {string} gamixAppId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAccountsControllerDelete(gamixAppId: string, id: string, options?: any): AxiosPromise<void> {
            return localVarFp.serviceAccountsControllerDelete(gamixAppId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Service Accounts
         * @param {string} gamixAppId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceAccountsControllerList(gamixAppId: string, options?: any): AxiosPromise<ListServiceAccountsResponse> {
            return localVarFp.serviceAccountsControllerList(gamixAppId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceAccountsApi - object-oriented interface
 * @export
 * @class ServiceAccountsApi
 * @extends {BaseAPI}
 */
export class ServiceAccountsApi extends BaseAPI {
    /**
     * 
     * @summary Create new service account
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAccountsApi
     */
    public serviceAccountsControllerCreate(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return ServiceAccountsApiFp(this.configuration).serviceAccountsControllerCreate(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Service Account
     * @param {string} gamixAppId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAccountsApi
     */
    public serviceAccountsControllerDelete(gamixAppId: string, id: string, options?: RawAxiosRequestConfig) {
        return ServiceAccountsApiFp(this.configuration).serviceAccountsControllerDelete(gamixAppId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Service Accounts
     * @param {string} gamixAppId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceAccountsApi
     */
    public serviceAccountsControllerList(gamixAppId: string, options?: RawAxiosRequestConfig) {
        return ServiceAccountsApiFp(this.configuration).serviceAccountsControllerList(gamixAppId, options).then((request) => request(this.axios, this.basePath));
    }
}



